import React from 'react';

const WeightStats = ({ dateRange, entries }) => {
  // Filter weight entries based on date range
  const weightEntries = entries
    .filter(entry => entry.type === 'weight')
    .filter(entry => {
      if (!dateRange.start && !dateRange.end) return true;
      
      const entryDate = new Date(entry.datetime);
      const startDate = dateRange.start ? new Date(dateRange.start) : null;
      const endDate = dateRange.end ? new Date(dateRange.end) : null;
      
      if (startDate) startDate.setHours(0, 0, 0, 0);
      if (endDate) endDate.setHours(23, 59, 59, 999);
      
      if (startDate && entryDate < startDate) return false;
      if (endDate && entryDate > endDate) return false;
      return true;
    })
    .sort((a, b) => new Date(a.datetime) - new Date(b.datetime));

  if (weightEntries.length < 2) {
    return (
      <div className="bg-white rounded-2xl shadow-md hover:shadow-lg transition-shadow p-2 sm:p-4 border border-blue-100">
        <h4 className="text-sm sm:font-medium text-gray-800 mb-1 sm:mb-2">Weight Change</h4>
        <div className="text-gray-600 text-xs sm:text-sm">
          {weightEntries.length === 0 
            ? "No weight data available" 
            : "Need at least 2 weight entries"}
        </div>
      </div>
    );
  }

  // Get first and last weight entries in the range
  const firstEntry = weightEntries[0];
  const lastEntry = weightEntries[weightEntries.length - 1];
  
  const startWeight = parseFloat(firstEntry.value);
  const endWeight = parseFloat(lastEntry.value);
  
  const weightChange = (endWeight - startWeight).toFixed(1);
  const percentChange = ((endWeight - startWeight) / startWeight * 100).toFixed(1);
  
  // Determine if weight increased, decreased, or stayed the same
  let changeDirection = "maintained";
  let changeColor = "text-gray-700";
  let trendIcon = "→";
  
  if (weightChange > 0) {
    changeDirection = "gained";
    changeColor = "text-rose-600";
    trendIcon = "↑";
  } else if (weightChange < 0) {
    changeDirection = "lost";
    changeColor = "text-emerald-600";
    trendIcon = "↓";
  }

  return (
    <div className="bg-white rounded-2xl shadow-md hover:shadow-lg transition-shadow p-2 sm:p-4 border border-blue-100">
      <h4 className="text-sm sm:font-medium text-gray-800 mb-1 sm:mb-2">Weight Change</h4>
      <div>
        <div className="text-lg sm:text-2xl font-bold text-teal-700 mb-1">
          {Math.abs(weightChange)} kg {trendIcon}
          <span className={`text-xs sm:text-base font-normal ml-1 sm:ml-2 ${changeColor}`}>
            {Math.abs(percentChange)}% {changeDirection === 'gained' ? 'up' : changeDirection === 'lost' ? 'down' : ''}
          </span>
        </div>
        <div className="text-xs text-gray-500 mt-1">
          {startWeight} → {endWeight} kg
        </div>
      </div>
    </div>
  );
};

export default WeightStats;
